import React from "react";
import { useParams } from "react-router-dom";

const LeagueHome = () => {
  const { league } = useParams();

  return (
    <div>
      League Home
      <p>{league} info</p>
    </div>
  );
};

export default LeagueHome;
